  document.addEventListener("DOMContentLoaded", function () {
    const modal = document.getElementById("lhVideoModal");
    const iframe = document.getElementById("lhVideoIframe");
    const openButtons = document.querySelectorAll(".lh-video-open");
    const closeButton = document.querySelector(".lh-video-close");
    const modalBackground = document.querySelector(".lh-video-modal-bg");

    function openVideo(videoId) {
      iframe.src = "https://www.youtube-nocookie.com/embed/" + videoId + "?autoplay=1&rel=0";
      modal.classList.add("active");
      document.body.style.overflow = "hidden";
    }

    function closeVideo() {
      modal.classList.remove("active");
      iframe.src = "";
      document.body.style.overflow = "";
    }

    openButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        openVideo(button.getAttribute("data-video"));
      });
    });

    closeButton.addEventListener("click", closeVideo);
    modalBackground.addEventListener("click", closeVideo);

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        closeVideo();
      }
    });
  });